import { gql } from "@apollo/client";

export const FETCH_NUM_ATTEMPTS_TO_SUPPORT_CAMPAIGN = gql`
  query NumAttemptsToSupportCampaign($campaignId: ID!) {
    numAttemptsToSupportCampaign(campaignId: $campaignId)
  }
`;
